var cardSelector = (function() {
	var $cardSelector, $selectedIndex, $selectCardButton, $selectedMethodContainer, $methodSelectList;
	var methodSelectListOpen = false;

	var init = function () {
		$cardSelector = $(".card-selector");

		if (!$cardSelector.length) {
			return;
		}

		$selectedIndex = $cardSelector.find("input.selected-index");
		$selectCardButton = $("[data-action=select-card]");
		$selectedMethodContainer = $cardSelector.find(".selected-card-container");
		$methodSelectList = $cardSelector.find(".selector-box");

		// Show selected card reference on load
		$methodSelectList.find(".card-reference").each(function () {
			if (getPaymentMethodIndex($(this)) === $selectedIndex.val()) {
				showSelectedCardReference($(this));
				return false;
			}
		});

		if (!$selectCardButton.length) {
			return; // No payment selector present
		}
		// Setup showing of payment methods
		$selectCardButton.on("click", showPaymentMethods);

		// Setup selection of paymnet methods
		$methodSelectList.on("click touch", ".selector-item", selectPaymentMethod);
	};

	var showPaymentMethods = function ( ) { //this has e as an arugment but not used
		if (!methodSelectListOpen) {
			$selectedMethodContainer.hide();
			$methodSelectList.show();
		} else {
			$selectedMethodContainer.show();
			$methodSelectList.hide();
		}
		toggleMethodList();
	};

	var selectPaymentMethod = function ( ) {//this has e as an arugment but not used
		var $cardReference = $(this).find(".card-reference");
		var selectedPaymentMethodIndex = $cardReference.attr("data-payment-method-index");

		updateSelectedIndex(selectedPaymentMethodIndex);
		showSelectedCardReference($cardReference);
		toggleMethodList();
	};

	var updateSelectedIndex = function(index) {
		$selectedIndex.val(index);
	};

	var showSelectedCardReference = function (cardReference) {
		$methodSelectList.hide();
		$selectedMethodContainer
			.html(cardReference.parent().html())
			.show();
	};

	var getPaymentMethodIndex = function(cardReference) {
		return cardReference.attr("data-payment-method-index");
	};

	var toggleMethodList = function() {
		methodSelectListOpen = !methodSelectListOpen;
	};

	return { init: init };
}());

$(function() {
	cardSelector.init();
});
